import { PlaneCreate } from '~/modules/sites';
import { usePageTitle } from '~components/DashboardWrapper/PageTitle';
import { t } from '~/i18n';

export default function SitePlaneCreatePage() {
  usePageTitle(t('menu.dashboard.settingsSites'), { heading: false });
  return <PlaneCreate />;
}
